import { fetchApi } from '@/app/api';

export function fetchUsers() {
  // Exclude never-activated accounts (no loginname). They have no usable
  // identity to render and would show up as empty badges.
  return fetchApi('/users', { loginname: 'neq.' });
}
